if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');

      this.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') this.close();
      });

      this.bindOverlay();
      this.setHeaderCartIconAccessibility();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event = {}) => {
          const count = event.cartData && typeof event.cartData.item_count === 'number' ? event.cartData.item_count : null;
          if (count !== null) this.updateHeaderBadges(count);
          else this.syncCartCount();
          window.setTimeout(() => this.bindOverlay(), 0);
        });
      }
    }

    disconnectedCallback() {
      if (typeof this.cartUpdateUnsubscriber === 'function') this.cartUpdateUnsubscriber();
    }

    bindOverlay() {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (!overlay || overlay.dataset.bound === 'true') return;
      overlay.dataset.bound = 'true';
      overlay.addEventListener('click', () => this.close());
    }

    getCartTriggers() {
      return Array.from(document.querySelectorAll('#cart-icon-bubble, [data-cart-trigger], .ls-cart-trigger'));
    }

    setHeaderCartIconAccessibility() {
      const triggers = this.getCartTriggers();
      if (!triggers.length) return;

      triggers.forEach((cartLink) => {
        if (!cartLink || cartLink.dataset.drawerBound === 'true') return;

        cartLink.dataset.drawerBound = 'true';
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');

        cartLink.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(cartLink);
        });

        cartLink.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() !== 'SPACE') return;
          event.preventDefault();
          this.open(cartLink);
        });
      });
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);

      requestAnimationFrame(() => {
        this.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      });

      window.setTimeout(() => {
        const focusContainer = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty') || this.querySelector('.drawer__inner')
          : this.querySelector('.drawer__inner');
        const focusTarget = this.querySelector('.drawer__close') || focusContainer;

        if (focusContainer && focusTarget && typeof trapFocus === 'function') {
          trapFocus(focusContainer, focusTarget);
        }
      }, 240);
    }

    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
    }

    renderContents(parsedState) {
      this.classList.toggle('is-empty', parsedState.item_count === 0);
      this.productId = parsedState.id;

      this.getSectionsToRender().forEach((section) => {
        const sectionMarkup = parsedState.sections && parsedState.sections[section.id];
        if (!sectionMarkup) return;

        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        if (!sectionElement) return;

        const newContent = this.getSectionInnerHTML(sectionMarkup, section.selector);
        if (typeof newContent === 'string') sectionElement.innerHTML = newContent;
      });

      this.bindOverlay();
      this.setHeaderCartIconAccessibility();

      if (typeof parsedState.item_count === 'number') this.updateHeaderBadges(parsedState.item_count);
      else this.syncCartCount();

      this.open();

      document.dispatchEvent(
        new CustomEvent('lessul:cart-updated', {
          detail: { itemCount: parsedState.item_count, cartData: parsedState },
        })
      );
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const element = documentFragment.querySelector(selector);
      return element ? element.innerHTML : '';
    }

    getSectionsToRender() {
      return [
        { id: 'cart-drawer', selector: '#CartDrawer' },
        { id: 'cart-icon-bubble' },
      ];
    }

    updateHeaderBadges(count) {
      const safeCount = Number(count) || 0;
      document.querySelectorAll('[data-cart-badge]').forEach((badge) => {
        badge.textContent = String(safeCount);
        badge.classList.toggle('is-hidden', safeCount <= 0);
      });

      document.querySelectorAll('[data-mf-cart-count-number]').forEach((badge) => {
        badge.textContent = String(safeCount);
      });

      document.querySelectorAll('[data-mf-cart-count], .mf-cart-count-bubble').forEach((badge) => {
        badge.classList.toggle('is-hidden', safeCount <= 0);
        badge.hidden = safeCount <= 0;
      });
    }

    syncCartCount() {
      fetch(`${window.routes?.cart_url || '/cart'}.js`, { credentials: 'same-origin' })
        .then((response) => (response.ok ? response.json() : null))
        .then((cart) => {
          if (cart && typeof cart.item_count === 'number') this.updateHeaderBadges(cart.item_count);
        })
        .catch(() => {});
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}

if (!customElements.get('cart-drawer-items')) {
  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      ];
    }
  }

  customElements.define('cart-drawer-items', CartDrawerItems);
}
